// eslint-disable-next-line import/no-unresolved
import 'vite/modulepreload-polyfill';
import get from 'lodash.get';
import {
  utagDirectiveName,
  utagDirective,
  initializeGA4,
} from '@garmin/support-analytics';
import { createApp, h } from 'vue';
import store from '../store/store';
import TransitionView from '../views/Transition.vue';

import('lazysizes');

const app = createApp({ render: () => h(TransitionView) })
  .use(store);

app.config.globalProperties.$translations = window?.AppData?.translations || {};
app.config.globalProperties.$safeGet = get;
app.config.compilerOptions.whitespace = 'preserve';

utagDirective.inserted = utagDirective.mounted;
app.directive(utagDirectiveName, utagDirective);

initializeGA4();

app.mount('#transition');
